import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check, Star } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Pricing() {
  return <section id="pricing" className="bg-light py-12 md:py-24 px-4 relative overflow-hidden" data-id="element-178">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-180">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-181">
            Tu Inversión Hoy
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline" data-id="element-182">
            Empieza tu negocio hoy mismo
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-183">
          {/* Offer Card — first on mobile, right on desktop */}
          <motion.div id="offer" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-[32px] shadow-2xl border border-border p-8 md:p-10 text-center relative order-first lg:order-last" data-id="element-184">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-dark text-white font-bold px-6 py-2 rounded-full shadow-lg whitespace-nowrap text-sm tracking-wide" data-id="element-185">
              OFERTA DE LANZAMIENTO
            </div>

            <div className="mt-6 mb-8" data-id="element-186">
              <p className="text-slate-400 font-medium mb-2 line-through text-xl" data-id="element-187">
                Valor Normal: $47.00 USD
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-188">
                <span className="text-7xl text-dark font-display font-black tracking-tighter" data-id="element-189">
                  $6.36
                </span>
                <span className="text-2xl font-bold text-slate-400 mt-4" data-id="element-190">
                  USD
                </span>
              </div>
            </div>

            <div className="bg-slate-50 rounded-[20px] p-6 mb-8 border border-border" data-id="element-191">
              <ul className="text-left space-y-4" data-id="element-192">
                {['Sistema Mamá IA (PDF Completo)', 'Pack de Portadas Profesionales', 'Scripts de Cierre WhatsApp', 'Directorio de Videos Faceless', 'Acceso Inmediato y de Por Vida'].map((item, i) => <li key={i} className="flex items-center gap-3 text-dark font-medium" data-id="element-193">
                    <div className="bg-primary/10 p-1.5 rounded-full flex-shrink-0" data-id="element-194">
                      <Check className="w-4 h-4 text-primary" data-id="element-195" />
                    </div>
                    {item}
                  </li>)}
              </ul>
            </div>

            <motion.a href="https://www.vitarutinas.com/cart/50347583471862:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="shimmer-cta block w-full bg-cta hover:bg-rose-600 text-white font-bold rounded-full px-8 py-5 text-lg shadow-xl shadow-cta/20 text-center relative overflow-hidden" animate={{
            scale: [1, 1.04, 1]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.07
          }} whileTap={{
            scale: 0.97
          }} data-id="element-196">
              SÍ, QUIERO EMPEZAR POR $6.36
            </motion.a>
            <p className="text-sm text-slate-500 mt-6 font-medium flex items-center justify-center gap-2" data-id="element-197">
              <ShieldCheck className="w-4 h-4" data-id="element-198" /> Pago seguro · Acceso inmediato
            </p>
          </motion.div>

          {/* Supporting info — second on mobile, left on desktop */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8 order-last lg:order-first" data-id="element-199">
            <div className="bg-white rounded-[24px] p-8 border border-border shadow-sm" data-id="element-200">
              <div className="flex items-center gap-4 mb-6" data-id="element-201">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-202">
                  <Star className="w-6 h-6 text-primary fill-primary" data-id="element-203" />
                </div>
                <h3 className="text-2xl font-display font-bold text-dark" data-id="element-204">
                  ¿Por qué solo $6.36?
                </h3>
              </div>
              <p className="text-lg text-body leading-relaxed mb-6" data-id="element-205">
                Quiero que el precio no sea una excusa. Por menos de lo que
                cuesta un café en Starbucks, puedes tener el sistema completo
                para empezar a generar ingresos desde tu celular. Mi objetivo es
                que tengas resultados rápidos y te conviertas en mi próximo caso
                de éxito.
              </p>
            </div>

            <div className="bg-gradient-to-br from-white to-slate-50 rounded-[24px] border border-border p-8 shadow-sm relative overflow-hidden" data-id="element-206">
              <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-2xl" data-id="element-207"></div>
              <div className="flex flex-col sm:flex-row items-start gap-6 relative z-10" data-id="element-208">
                <div className="bg-white p-3 rounded-2xl shadow-sm border border-border flex-shrink-0" data-id="element-209">
                  <ShieldCheck className="w-10 h-10 text-primary" data-id="element-210" />
                </div>
                <div data-id="element-211">
                  <h4 className="font-display font-bold text-dark mb-3 text-xl" data-id="element-212">
                    Garantía de 7 Días
                  </h4>
                  <p className="text-body leading-relaxed" data-id="element-213">
                    Prueba el sistema completo sin riesgo. Si aplicas los pasos
                    y sientes que no es para ti, envíame un correo y te devuelvo
                    el 100% de tu dinero. Tienes 7 días para decidir.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}